// Generated types for DataFlow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLBehaviorReadAPI, SysMLBehaviorWriteAPI } from './sysmlbehavior';
import { SysMLBehaviorReadAPISchemaObject, SysMLBehaviorWriteAPISchemaObject } from './sysmlbehavior';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DataFlowReadAPI extends SysMLBehaviorReadAPI {
  /** Data transmission rate */
  data_rate?: string | null;
  /** Communication protocol */
  protocol?: string | null;
}

export interface DataFlowWriteAPI extends SysMLBehaviorWriteAPI {
  /** Data transmission rate */
  data_rate?: string | null;
  /** Communication protocol */
  protocol?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DataFlowReadAPISchema: z.ZodType<DataFlowReadAPI> = SysMLBehaviorReadAPISchemaObject.extend({
  data_rate: z.string().nullable().optional(),
  protocol: z.string().nullable().optional(),
}).passthrough();

export const DataFlowWriteAPISchema: z.ZodType<DataFlowWriteAPI> = SysMLBehaviorWriteAPISchemaObject.extend({
  data_rate: z.string().nullable().optional(),
  protocol: z.string().nullable().optional(),
}).passthrough();
